class CollectionProductCount extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      productsGrid: '[data-products-grid]',
      collectionLoop: '#CollectionLoop',
      productItem: '.grid-item.product-item:not(.product-item--featured-image)',
      productsCountElement: '.products_count'
    };

    this.totalProducts = 0;
    this.observer = null;
  }

  connectedCallback() {
    this._initializeTotal();
    this.updateCount();

    document.addEventListener('products:loaded', () => {
      this.updateCount();
    });

    this._observeProductGrid();
  }

  _initializeTotal() {
    const totalAttr = this.getAttribute('data-total-products');
    if (totalAttr) {
      this.totalProducts = parseInt(totalAttr, 10);
      return;
    }

    const countElement = this.querySelector(this._selectors.productsCountElement);
    if (countElement) {
      const text = countElement.textContent || '';
      const match = text.match(/of\s+(\d+)\s+products/i);
      if (match && match[1]) {
        this.totalProducts = parseInt(match[1], 10);
      }
    }
  }

  _observeProductGrid() {
    const productsGrid = document.querySelector(this._selectors.productsGrid);
    if (!productsGrid) return;

    this.observer = new MutationObserver(() => {
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.updateCount();
      }, 100);
    });

    this.observer.observe(productsGrid, {
      childList: true,
      subtree: true
    });
  }

  updateCount() {
    const collectionLoop = document.querySelector(this._selectors.collectionLoop);
    if (!collectionLoop) return;

    const productItems = collectionLoop.querySelectorAll(this._selectors.productItem);
    const visibleCount = productItems.length;
    let total = this.totalProducts;
    
    const pagination = document.querySelector('.pagination-custom');
    if (pagination) {
      const hasNextPage = pagination.querySelector('.pagination-custom__next:not(.is-inactive)');
      if (!hasNextPage && visibleCount > 0) {
        total = visibleCount;
      }
    } else {
      if (visibleCount > 0) {
        total = visibleCount;
      }
    }

    if (total !== this.totalProducts && total > 0) {
      this.totalProducts = total;
      this.setAttribute('data-total-products', total);
    }

    const countElement = this.querySelector(this._selectors.productsCountElement);
    if (countElement) {
      countElement.innerHTML = `Showing ${visibleCount} of ${total} products`;
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
  }
}

customElements.define('collection-product-count', CollectionProductCount);

